import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@material-ui/core';
import GradButton from './GradButton';

const buttonClassName = 'normal-case text-sm py-2 text-medium sm-w-140px';

function CancelConfirmButtons(props) {
  const { confirmActive, onCancel, onConfirm, className, confirmText, hideCancelButton } = props;
  return (
    <div className={`flex justify-end ${className}`}>
      {!hideCancelButton && (
        <Button
          className={classNames('text-gray-dark mr-4 border-gray-default', buttonClassName)}
          onClick={onCancel}
        >
          Cancel
        </Button>
      )}
      <GradButton className="sm-w-140px text-sm" active={confirmActive} onClick={onConfirm}>
        {confirmText}
      </GradButton>
    </div>
  );
}

CancelConfirmButtons.propTypes = {
  confirmActive: PropTypes.bool,
  hideCancelButton: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  className: PropTypes.string,
  confirmText: PropTypes.string
};

CancelConfirmButtons.defaultProps = {
  confirmActive: false,
  hideCancelButton: false,
  className: '',
  confirmText: 'Confirm'
};

export default CancelConfirmButtons;
